<template>
  <div>
    <v-bottom-navigation
      color="info"
      horizontal
      :background-color="colorfrist"
      dark
    >
      <v-btn to="/admin/gov_em/period_mgovem">
        <span>กำหนดการ </span>
        <v-icon>mdi-numeric-0-box</v-icon>
      </v-btn>

       <v-btn to="/admin/gov_em_vec/government_employee">
        <span>อัตรากำลัง ส่วนกลาง</span>
        <v-icon>mdi-numeric-1-box</v-icon>
      </v-btn>

        <v-btn to="/admin/gov_em_vec/assessment_govem">
        <span>ประเมิน ส่วนกลาง</span>
        <v-icon>mdi-numeric-2-box</v-icon>
      </v-btn>

      <v-btn to="/admin/gov_em/Governmentemployeereportadmin">
        <span>อัตรากำลัง สถานศึกษา</span>
        <v-icon>mdi-numeric-3-box</v-icon>
      </v-btn>      

      <v-btn to="/admin/gov_em/government_employee">
        <span>กรอบอัตรากำลัง</span>
        <v-icon>mdi-numeric-4-box</v-icon>
      </v-btn>   
      
      <v-btn to="/admin/gov_em/government_employee_report">
        <span>รายงานกรอบอัตรากำลัง</span>
        <v-icon>mdi-numeric-5-box</v-icon>
      </v-btn>   

      <v-btn to="/admin/government_employee_report_snp">
        <span>รายงานข้อมูลการเบิกจ่าย สนผ.</span>
        <v-icon>mdi-numeric-6-box</v-icon>
      </v-btn>   

      
    </v-bottom-navigation>
  </div>
</template>

<script>
export default {
  name: "HRvecMovementmenu",

  data() {
    return {};
  },

  mounted() {},

  methods: {},
  computed: {
    colorfrist() {
      return "#8F17B0FF";
    },
    colorsecord() {
      return "#280606FF";
    }
  }
};
</script>

<style lang="scss" scoped></style>
